export default "__VITE_ASSET__BTfiG2oD__"